<template>
	<v-container class="pa-0">
		<v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%" />

		<v-form v-if="!isLoading" ref="form">
			<!-- tipoDocumentoAudFirma{{ this.tipoDocumentoAudFirma }} -->
			<v-row style="margin: 0;" v-if="declaracionResponsablePendiente">
				<v-col cols="12" md="12" class="mx-auto">
					<h3 style="text-decoration:underline;" class="mb-3">Declaración responsable pendiente</h3>
				</v-col>
				<v-col>
					<div v-html="declaracionResponsablePendiente" />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="12" class="mx-auto mt-n7" v-if="declaracionResponsablePendiente">
					<v-checkbox v-model="cbDeclaracionResponsablePendiente"
						:label="'Entiendo y acepto la información de la declaración responsable pendiente'" />
				</v-col>
			</v-row>

			<v-row style="margin: 0;" v-if="declaracionResponsable">
				<v-col cols="12" md="12" class="mx-auto">
					<h3 style="text-decoration:underline;" class="mb-3">Declaración responsable</h3>
				</v-col>
				<v-col>
					<div v-html="declaracionResponsable" />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="12" class="mx-auto mt-n7" v-if="declaracionResponsable">
					<v-checkbox v-model="cbDeclaracionResponsable"
						:label="'Entiendo y acepto la información de la declaración responsable'" />
				</v-col>
			</v-row>

			<v-row style="margin: 0;" v-if="declaracionJurada" class="mt-5">
				<v-col cols="12" md="12" class="mx-auto">
					<h3 style="text-decoration:underline;" class="mb-3">Declaración jurada</h3>
				</v-col>
				<v-col>
					<div v-html="declaracionJurada" />
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12" md="12" class="mx-auto mt-n7" v-if="declaracionJurada">
					<v-checkbox v-model="cbDeclaracionJurada"
						:label="'Entiendo y acepto la información de la declaración jurada'" />
				</v-col>
			</v-row>

			<v-row style="margin: 0;" v-if="isDeclaraciones" class="mt-10">
				<v-col cols="12" class="mx-auto" style="display:flex">
					<span>En</span>
					<v-text-field outlined class="mt-n4 ml-3 mr-3" style="max-width:300px" ref='solicitante.lugarFirma'
						v-rest-validation v-model="lugarFirma" :rules="[validationRules.required]"
						@keydown.enter.prevent />
					<span>a {{ formatLongLocalDate() }}</span>
				</v-col>
			</v-row>
			<v-row v-if="isDeclaraciones">
				<v-col cols="12" class="mx-auto">
					<span>Firmado:</span>
				</v-col>
				<v-col cols="4" class="mx-auto">
					<v-text-field outlined ref='tramitadorNombre' v-rest-validation v-model="firmante.nombre"
						autocomplete="off"
						:rules="[validationRules.required, validationRules.maxLength(firmante.nombre, 200)]"
						label="Nombre" @keydown.enter.prevent />
				</v-col>
				<v-col cols="4" class="mx-auto">
					<v-text-field outlined ref='tramitadorPrimerApellido' v-rest-validation v-model="firmante.apellido1"
						autocomplete="off"
						:rules="[validationRules.required, validationRules.maxLength(firmante.apellido1, 200)]"
						label="Primer apellido" @keydown.enter.prevent />
				</v-col>
				<v-col cols="4" class="mx-auto">
					<v-text-field outlined ref='tramitadorSegundoApellido' v-rest-validation
						v-model="firmante.apellido2" autocomplete="off"
						:rules="[validationRules.maxLength(firmante.apellido2, 200)]" label="Segundo apellido"
						@keydown.enter.prevent />
				</v-col>
				<v-col cols="4">
					<v-text-field outlined ref='tramitadorDni' v-rest-validation v-model="firmante.dni"
						autocomplete="off" :rules="[validationRules.required, validationRules.dni]" label="DNI o NIE"
						@keydown.enter.prevent />
				</v-col>
			</v-row>

			<v-row class="mb-6">
				<v-col cols="11" md="6">
					<v-btn class="btn-prev" @click="continuePrev" color="umivalesecondary">Anterior
					</v-btn>
				</v-col>
				<v-col cols="11" md="6">
					<v-btn class="btn-next" style="float:right;" @click="continueNext()"
						:disabled="!isDeclaracionesAceptadasYFirmadas || isLoading" color="primary">Guardar
					</v-btn>
				</v-col>
			</v-row>

		</v-form>

	</v-container>
</template>

<script>
import api from '@Base/services/auditoriaService'
import StepBase from './common/StepBase.js'
import { mapGetters } from 'vuex';
import { tiposAlegacion, tiposTramiteAudiencia, tiposCircuitoAbono, SOL_TIPO_DOCUMENTO } from '../conf/constants'

export default {
	name: 'DeclaracionesMain',
	mixins: [StepBase],
	data() {
		return {
			isLoading: false,
			modoCodigo: false,
			//consentimiento: false,
			cbDeclaracionResponsablePendiente: false,
			cbDeclaracionResponsable: false,
			cbDeclaracionJurada: false,
			//telefonoFirma: null,
			//idFirmaDocumento: null,
			tokenGestion: null,
			showDialog: false,
			codigo: null,
			data: null,
			declaracionResponsablePendiente: null,
			declaracionResponsable: null,
			declaracionJurada: null,
			codeErrorMessage: null,
			//fechaFirma: null,
			lugarFirma: null,
			/*solicitante: {
					  idSolicitante: null,
					  motivo: 1,  // 1 -> Reducción de la facturación en al menos un 75% ; 2 -> Suspensión de la actividad por consecuencia directa de la declaración del estado de alarma
					  fechaDeclaracionResponsable: null,
					  fechaDeclaracionJurada: null,
					  fechaFirma: null,
					  lugarFirma: null
				  },*/
			firmante: {
				nombre: null,
				apellido1: null,
				apellido2: null,
				dni: null,
			},
		}
	},

	computed: {
		...mapGetters({
			tipoDocumentoAudFirma: 'solicitud/tipoDocumentoAudFirma',
		}),
		isDeclaraciones() {
			return this.declaracionResponsablePendiente || this.declaracionResponsable || this.declaracionJurada;
		},
		isDeclaracionesAceptadasYFirmadas() {
			var declaracionResponsablePendienteOk = !this.declaracionResponsablePendiente || (this.declaracionResponsablePendiente && this.cbDeclaracionResponsablePendiente);
			var declaracionResponsableOk = !this.declaracionResponsable || (this.declaracionResponsable && this.cbDeclaracionResponsable);
			var declaracionJuradaOk = !this.declaracionJurada || (this.declaracionJurada && this.cbDeclaracionJurada);
			var lugarFirmaOK = this.lugarFirma && this.lugarFirma.trim().length > 0;
			var firmanteOK = this.firmante.nombre && this.firmante.nombre.trim().length > 0 && this.firmante.apellido1 && this.firmante.apellido1.trim().length > 0 && this.firmante.dni && this.firmante.dni.trim().length > 0;
			return declaracionResponsablePendienteOk && declaracionResponsableOk && declaracionJuradaOk && lugarFirmaOK && firmanteOK;
		}
	},
	methods: {
		continuePrev: function () {
			// dependiendo del tipo de documento, dirige hacia una ruta específica
			// const tiposAlegacion = [SOL_TIPO_DOCUMENTO.PECATA_NOTIFICACION_ALEGACION, SOL_TIPO_DOCUMENTO.PECATA_SUBSANACION_ALEGACION];
			// const tiposTramiteAudiencia = [SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_NOTIFICACION, SOL_TIPO_DOCUMENTO.PECATA_TRAMITE_AUDIENCIA_SUBSANACION];
			// const tiposCircuitoAbono = [SOL_TIPO_DOCUMENTO.PECATA_SOLICITUD_IBAN, SOL_TIPO_DOCUMENTO.PECATA_CONFIRMACION_IBAN];
			let routeName = '';
			// tipos definidos en el fichero constans
			if (tiposAlegacion.includes(this.tipoDocumentoAudFirma)) {
				routeName = 'documentos-alegacion';
			} else if (tiposTramiteAudiencia.includes(this.tipoDocumentoAudFirma)) {
				routeName = 'subsanaciones';
			} else if (tiposCircuitoAbono.includes(this.tipoDocumentoAudFirma)) {
				routeName = 'comprobar-iban';
			}

			if (routeName) {
				this.$router.push({ name: routeName, params: { id: this.$store.state.solicitud.tokenAcceso, notificacion: this.$store.state.solicitud.idNotificacion } });
			}
		},

		continueNext: function () {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.isLoading = true;
			this.data.lugarFirma = this.lugarFirma;
			this.data.fechaFirma = new Date();
			this.data.tramitadorNombre = this.firmante.nombre;
			this.data.tramitadorPrimerApellido = this.firmante.apellido1;
			this.data.tramitadorSegundoApellido = this.firmante.apellido2 && this.firmante.apellido2.length > 0 ? this.firmante.apellido2 : null;
			this.data.tramitadorDni = this.firmante.dni;
			this.data.idNotificacion = this.checkAndParseNotificacion(!this.$store.state.solicitud.idNotificacion ? this.$store.state.solicitud.audFirma.notificacionOrigen : this.$store.state.solicitud.idNotificacion);
			api.firmarDeclaraciones(this.data,
				res => {
					this.isLoading = false;
					this.$router.push({ name: 'confirmar-subsanacion', params: { id: this.$store.state.solicitud.tokenAcceso, notificacion: this.$store.state.solicitud.idNotificacion } });
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al enviar las declaraciones', color: 'red' });
					console.log(error);
				}
			);
		},
		// eslint-disable-next-line no-unused-vars
		/*loadSolicitante: function (vm, params) {
			if (this.$refs.form != null) {
				this.$refs.form.resetValidation();
			}

			//if (!this.handleStepEntry(params.id)) return;

			this.isLoading = true;
			this.tokenGestion=this.$store.state.solicitud.tokenGestion;
			api.getDeclaracionresponsable(
			data => {
				this.solicitante=data.solicitante;
				this.idFirmaDocumento=data.pantalla.id;

				this.consentimiento = this.solicitante.fechaDeclaracionResponsable != null;
				this.cbDeclaracionJurada = this.solicitante.fechaDeclaracionJurada != null;

				this.obtenerDeclaraciones();
			},
			error => {
				//if (this.handleForbiddenNavigation(error)) return;
				this.$emit('alert-event', { text: 'Error al cargar la declaración responsable', color: 'red' });
				console.log(error);
			}
			);
		},*/
		obtenerDeclaraciones() {
			this.isLoading = true;

			api.obtenerDeclaraciones(
				data => {
					this.isLoading = false;
					this.data = data;
					this.declaracionResponsablePendiente = data.declaracionResponsablePendiente;
					this.cbDeclaracionResponsablePendiente = data.fechaFirma ? true : false;
					this.declaracionResponsable = data.declaracionResponsable;
					this.cbDeclaracionResponsable = data.fechaFirma ? true : false;
					this.declaracionJurada = data.declaracionJurada;
					this.cbDeclaracionJurada = data.fechaFirma ? true : false;
					this.lugarFirma = data.lugarFirma;
					this.firmante.nombre = data.tramitadorNombre ? data.tramitadorNombre : null;
					this.firmante.apellido1 = data.tramitadorPrimerApellido ? data.tramitadorPrimerApellido : null;
					this.firmante.apellido2 = data.tramitadorSegundoApellido ? data.tramitadorSegundoApellido : null;
					this.firmante.dni = data.tramitadorDni ? data.tramitadorDni : null;
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al cargar el texto de declaración responsable', color: 'red' });
					console.log(error);
				});
		},
		checkAndParseNotificacion(idNotificacion = null) {
			const errorMessage = { text: 'Error al obtener la notificación', color: 'red' };
			const isValid = idNotificacion !== null && idNotificacion !== undefined;

			if (isValid) {
				const notificacionNumber = Number(idNotificacion);

				if (!isNaN(notificacionNumber)) {
					return notificacionNumber;
				}
			}
			this.$emit('alert-event', errorMessage);
		}
	},
	watch: {
		$route(to) {
			this.obtenerDeclaraciones();
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.obtenerDeclaraciones();
			//vm.setStepInfo(vm.getStepCount(vm.stepId), vm.getStepCount(vm.stepId)+'. Declaración responsable');
		})
	}
}
</script>